export var UserType;
(function (UserType) {
    UserType["PARTICIPANT"] = "participant";
    UserType["PROFESSIONAL"] = "professional";
})(UserType || (UserType = {}));
